export default function customerPermissions() {
  return {
    template: require('./customer-permissions.html'),
    restrict: 'E',
    replace: true,
    scope: {
      expanded: '=',
      userRoles: '=',
    },
  };
}
